// add text upload resume or Upload cover letter if no file are prefilled in job application
document.addEventListener("DOMContentLoaded", function () {
    let fileInputs = document.querySelectorAll('input[type="file"]');

    function updateDataTitle(fileInput) {
        let container = fileInput.closest(".form-element-file");
        if (container) {
            if (fileInput.files.length > 0) {
                // Set data-title to the selected file name
                container.setAttribute("data-title", fileInput.files[0].name);
                container.classList.add("file-uploaded");
            } else {
                 // Reset data-title to appropriate default based on ID
                 if (container.id === "resumeFile") {
                    container.setAttribute("data-title", "Upload Resume");
                } else{
                    container.setAttribute("data-title", "Upload Cover Letter"); // fallback
                }
                container.classList.remove("file-uploaded");
            }
        }
    }

    fileInputs.forEach(function (fileInput) {
        // Preserve existing data-title if already set (e.g., resume1.pdf)
        let container = fileInput.closest(".form-element-file");
        if (container && !container.getAttribute("data-title")) {
            if (container.id === "resumeFile") {
                container.setAttribute("data-title", "Upload Resume");
            }else{
                container.setAttribute("data-title", "Upload Cover Letter");
            }
        }

        // Add change event listener to update data-title
        fileInput.addEventListener("change", function () {
            updateDataTitle(fileInput);
        });
    });
});
